"use client";
import ToastContextProvider from "@workspace/casino_pages/legacyLayer/legacyUi/Toast/Context/ToastContextProvider";
import { getCookie } from "@workspace/cookies/browser";
import NftRewardNotificationView from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/NftRewardNotification/NftRewardNotificationView";

type Props = {
  notification: WorkerNotification;
  context: WorkerContext;
  onClose: () => void;
};

const NftRewardNotification: FC<Props> = ({
  notification,
  onClose,
  context,
}) => {
  if (!getCookie("token")) {
    return null;
  }
  return (
    <ToastContextProvider>
      <NftRewardNotificationView
        notification={{ normalNotification: notification.data }}
        onClose={onClose}
        context={context}
      />
    </ToastContextProvider>
  );
};

export default NftRewardNotification;
